export const ACADEMIC_DELIVERABLES_1_CONSTANTS = {
    DEFAULT_ROW: {},
  
    ACADEMIC_DELIVERABLES_FIELDS_CONFIG: [
      {
        fieldName: "title",
        label: "Title",
        value: "Academic Excellence",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Title",
        required: false,
        defaultValue: "Academic Excellence",
      },
      {
        fieldName: "title_text_color",
        label: "Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "sub_title",
        label: "Sub Title",
        value: "Our Academic Deliverables",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Sub Title",
        required: false,
        defaultValue: "Our Academic Deliverables",
      },
      {
        fieldName: "sub_title_text_color",
        label: "Sub Title Text Color",
        value: "#000000",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter sub title text color (e.g., #000000)",
        required: false,
        defaultValue: "#000000",
      },
      {
        fieldName: "desktop_bg_image",
        label: "Desktop Background Image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Desktop Background Image",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "mobile_bg_image",
        label: "Mobile Background Image",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Mobile Background Image",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "alt_image",
        label: "Alt Image Text",
        value: "Academic deliverables background",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Alt Image Text",
        required: false,
        defaultValue: "Academic deliverables background",
      },
      {
        fieldName: "button_text",
        label: "Button Text",
        value: "Learn More",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter Button Text",
        required: false,
        defaultValue: "Learn More",
      },
      {
        fieldName: "button_text_color",
        label: "Button Text Color",
        value: "#FFFFFF",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter button text color (e.g., #FFFFFF)",
        required: false,
        defaultValue: "#FFFFFF",
      },
      {
        fieldName: "button_background_color",
        label: "Button Background Color",
        value: "#BE2330",
        valueType: "string",
        filedType: "COLOR",
        placeholder: "Enter button background color (e.g., #BE2330)",
        required: false,
        defaultValue: "#BE2330",
      },
      {
        fieldName: "button_icon",
        label: "Button Icon",
        value: "",
        valueType: "string",
        filedType: "FILE",
        placeholder: "Upload Button Icon",
        required: false,
        defaultValue: "",
      },
      {
        fieldName: "button_icon_alt",
        label: "Button Icon Alt Text",
        value: "Learn more",
        valueType: "string",
        filedType: "INPUT",
        placeholder: "Enter alt text for button icon",
        required: false,
        defaultValue: "Learn more",
      },
      {
        fieldName: "status",
        label: "Status",
        value: false,
        valueType: "boolean",
        filedType: "TOGGLE",
        placeholder: "Enable/Disable Section",
        defaultValue: false,
      }
    ],
  
    METADATA_FIELDS: []
  };